
if (!customElements.get("brand-directory")) {
    customElements.define("brand-directory", class BrandDirectory extends HTMLElement {
        constructor() {
            super();
            // Could be letters, brand names, or just the collection of links in the nav
            this.headerLinks = this.querySelectorAll(".header-link");
            this.childLinks = this.querySelectorAll(".child-links");

            this.initHeaderLinkClicks();
            this.showFirstChildOrUriHashed();
        }

        initHeaderLinkClicks() {
            for (const headerLink of this.headerLinks) {
                const hash = headerLink.getAttribute("data-hash");
                headerLink.addEventListener("click", (evt) => {
                    this.showChildLink(hash);
                });
            }
        }

        showFirstChildOrUriHashed() {
            if (this.headerLinks.length > 0) {
                const hash = window.location.hash?.replace('#', '');
                this.showChildLink(hash ? hash : this.headerLinks[0].getAttribute("data-hash"));
            }
        }

        showChildLink(hash) {
            for (const childLink of this.childLinks) {
                const childHash = childLink.getAttribute("data-hash");
                if (hash == childHash) {
                    childLink.classList.remove("hidden");
                } else {
                    childLink.classList.add("hidden")
                }
            }
        }
    });
}